import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from '@eb/eds-icon';
import { ChevronDownChunky } from '@eb/eds-iconography';
import { gettext } from '@eb/i18n';

import { FeedBuilderContainer } from '../FeedBuilderContainer';
import { HomeLocationAutocompleteContainer } from '../HomeLocationAutocompleteContainer';
import { fetchEventsForTab } from '../../redux/events/';

import { StickyTabs } from '../../components/Tabs';

import { ALL_TAB, FEED_TABS } from '../../../../constants/tabConfig';
import {
    EVENT_SEARCH_PROPTYPES,
    LOCATION_PROP_TYPE,
} from '../../../../constants/propTypes';
import { BASE_SEASONAL_CONTENT_PROPTYPES } from '../../../../constants/seasonal';
import { inyectSeasonalTab, scrollIt } from '../../utils';

import './BrowseContainer.scss';

const Chevron = (
    <Icon type={<ChevronDownChunky />} color="ui-blue--hover" size="medium" />
);

export const ONLINE_EVENTS_INPUT_COPY = gettext('Popular ');

const LOCATION_AUTOCOMPLETE_PROPS = {
    prefix: Chevron,
    borderType: 'content',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

const shouldIncludeCurrentTab = ({ tabKey, tabsConfig, location }) => {
    if (!tabsConfig[tabKey]) {
        return false;
    }

    return true;
};

const getBrowseTabs = (seasonalContent, location) => {
    const tabsConfig = inyectSeasonalTab(seasonalContent);
    const tabs = [];

    FEED_TABS.forEach((tabKey, index) => {
        const shouldAddTab = shouldIncludeCurrentTab({
            tabKey,
            tabsConfig,
            location,
        });

        if (shouldAddTab) {
            const { name, eventSearch, follow, feedConfig } = tabsConfig[
                tabKey
            ];

            tabs.push({
                tabKey,
                value: index,
                displayName: name,
                content: (
                    <FeedBuilderContainer
                        feedConfig={feedConfig}
                        eventSearch={eventSearch}
                        follow={follow}
                        tabKey={tabKey}
                    />
                ),
            });
        }
    });

    return tabs;
};

const LocationComponent = () => {
    const copy = gettext('Popular in ');

    return (
        <div className="browse__location eds-l-pad-top-4">
            <div className="browse__location-text">{copy} </div>
            <HomeLocationAutocompleteContainer
                autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
                shouldDispatchSearchActions={true}
            />
        </div>
    );
};

const handleTabLoad = (tabKey, { fetchEventsForTab, isFeLoading }) => {
    /**
     * On first load we do not need to fetch new events ONLY for the all_tab.
     * The tab is loaded before the `fe` has finished fetching so we use that
     * variable to know if we are in the all tab to prevent fetching.
     */
    if ((!isFeLoading && tabKey === ALL_TAB) || tabKey !== ALL_TAB) {
        fetchEventsForTab({ tabKey, shouldUpdateContent: true });
    }
};

const handleTabChange = (tabKey, { fetchEventsForTab }) => {
    scrollIt(document.querySelector('.browse-section').offsetTop + 70);

    fetchEventsForTab({ tabKey, shouldUpdateContent: true });
};

const Browse = (props) => {
    const {
        tabKey,
        location,
        seasonalContent,
        fetchEventsForTab,
        isFeLoading,
        isNewHeader,
    } = props;
    const items = getBrowseTabs(seasonalContent, location);

    return (
        <div className="browse-section" id="browse-section">
            <LocationComponent location={location} />

            <StickyTabs
                items={items}
                isNewHeader={isNewHeader}
                onTabChange={(tabKey) =>
                    handleTabChange(tabKey, {
                        fetchEventsForTab,
                        isFeLoading,
                    })
                }
                onTabLoad={(tabKey) =>
                    handleTabLoad(tabKey, {
                        fetchEventsForTab,
                        isFeLoading,
                    })
                }
                initialSelectedTab={tabKey}
                location={location}
            />
        </div>
    );
};

Browse.propTypes = {
    fetchEventsForTab: PropTypes.func,
    eventSearch: EVENT_SEARCH_PROPTYPES,
    isAuthenticated: PropTypes.bool,
    tabKey: PropTypes.string,
    location: LOCATION_PROP_TYPE,
    seasonalContent: PropTypes.arrayOf(
        PropTypes.shape(BASE_SEASONAL_CONTENT_PROPTYPES),
    ),
    isFeLoading: PropTypes.bool,
};

const _mapStateToProps = (state) => ({
    isAuthenticated: state.user.isAuthenticated,
    tabKey: state.content.browseState.tabKey,
    isFeLoading: state.app.loadingState.isFeLoading,
    location: state.location,
    seasonalContent: state.content.seasonal,
    isNewHeader: state.app.featureFlags.launchHeader2021,
});

const _mapDispatchToProps = {
    fetchEventsForTab,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(Browse);
